import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WorkerHeader from "../../worker-header/components";
import WorkerFooter from "../../worker-footer/components";
import { toast } from "react-toastify";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

const WorkerPlanPaymentSuccess = () => {

    const [loading, setLoading] = useState(true);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

    useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const sessionId = urlParams.get("session_id");

  const finalizeBooking = async () => {
    const res = await fetch(`${BACKEND_URL}/verify-session`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ session_id: sessionId }),
    });

    const result = await res.json();

    // console.log("result", result);

if (result.success && result.data?.payment_status === "paid") {
  console.log("inside success result", result);

  const planPayload = {
    user_id: result.data.metadata.user_id,
    plan_id: result.data.metadata.plan_id,
    amount: result.data.metadata.amount,
    payment_status: result.data.payment_status,
    transaction_id: result.data.payment_intent,
  };

  const book = await fetch(`${BACKEND_URL}/memberships/plans`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(planPayload),
  });

  const planResult = await book.json();
  console.log("planResult:", planResult);

  toast.success("Plan Purchased Successfully", {
    position: "top-right",
    autoClose: 2000,
    style: { fontSize: "0.85rem" },
  });

  navigate("/panel/myplans");
}

  };

  if (sessionId) {
    finalizeBooking();
  }
}, []);

    if (loading) {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
      <i className="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
      <p className="h5">Verifying your payment...</p>
    </div>
  );
}

  if (error) return <p className="text-danger">{error}</p>;

    return (
        <>
            <WorkerHeader />
                <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            Payment Success
          </h4>
      {sessionInfo ? (
        <>
          <div className="text-center mt-5">
      <i className="fas fa-check-circle fa-3x text-success mb-3"></i>
      <h4>Payment verified successfully!</h4>
      <p>Redirecting to your dashboard...</p>
    </div>
        </>
      ) : (
        <p>No payment details available.</p>
      )}
    </div>
  </div>
            <WorkerFooter />
        </>
    );
};

export default WorkerPlanPaymentSuccess;